import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';
import NodeSvg from 'devicon/icons/nodejs/nodejs-plain.svg';

export const Node = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="lang-nodejs" className={cx('sdkIcon', className)} size={size} {...props}>
    <NodeSvg />
  </LegacyIcon>
);
